import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { IProductGroup } from '@toro/common/shared/interfaces/infoproducts/common.interfaces';
import { InfoproductsAction } from '@toro/common/shared/state-management/infoproducts/infoproducts.action';
import { ICustomerCourse, IAvailableCourse } from '@toro/common/shared/interfaces/infoproducts/course.interfaces';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { environment } from '../../../../../../src/environments/environment';

enum CoursesTypes  {
    MyCourses,
    AllCourses,
}

@AutoUnsubscribe()
@Component({
    selector: 'home-logged-courses',
    templateUrl: './courses.component.html',
    styleUrls: ['./courses.component.scss'],
    providers: [],
})
export class HomeLoggedCoursesComponent implements OnDestroy, OnInit {
    public isNewBrand = environment.isNewBrand

    public showSlides = false;
    public CoursesTypes = CoursesTypes;
    public filterCoursesBy: CoursesTypes = CoursesTypes.AllCourses;
    public coursesSubscription: Subscription;

    public mostViewedCourse: ICustomerCourse;
    public customerCourses: ICustomerCourse[];
    public availableCoursesByGroup = new Map<IProductGroup, IAvailableCourse[]>();

    public consultantButtonText = "Falar com um consultor";

    constructor(private store: Store<AppState>) {
        this.store.dispatch({ type: InfoproductsAction.getAvailableCourses });
        this.store.dispatch({ type: InfoproductsAction.getCustomerProducts });
    }

    public ngOnInit() {
        this.sendTracking(ActionEventsEnum.PAGE_LOADED, {
            'Product Area Origin': 'Aprenda',
            'Time Responsável': 'Sky',
            'Current URL': '/lp-toro-trader',
        });

        this.coursesSubscription = this.store
            .select(({ infoproducts }) => infoproducts)
            .subscribe(({ availableCourses, customerCourses }) => {

                this.customerCourses = Array.from(customerCourses.values());
                this.availableCoursesByGroup.clear();
                availableCourses.forEach((course) => {
                    if (course.group && course.group.id) {
                        const groupCourses = this.availableCoursesByGroup.get(course.group) || [];
                        this.availableCoursesByGroup.set(course.group, [...groupCourses, course]);
                    }
                    if (course.mostViewed && !this.mostViewedCourse) {
                        this.mostViewedCourse = course;
                    }
                });
            });
    }

    public ngOnDestroy() {
        // Necessary for the autounsubscribe to work
    }

    public setCourseFilter(filterBy: CoursesTypes) {
        this.filterCoursesBy = filterBy;
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }

    public onMostViewedCourseClick(courseName: string) {
        this.sendTracking(ActionEventsEnum.ELEMENT_CLICKED, {
            'Element': `Banner ${courseName}`,
            'Group': 'Curso mais visto',
            'Text': courseName,
            'Time Responsável': 'Sky',
        });
    }

    public onCarouselCourseClick(course: any, index: number, length: number) {
        this.sendTracking(ActionEventsEnum.ELEMENT_CLICKED, {
            'Product Area Origin': 'Aprenda',
            'Time Responsável': 'Sky',
            'Element': 'Card Curso',
            'Group': course.description,
            'Text': course.name,
            'Specific Properties': {
                'Quantidade de cards': length,
                'Card clicado': index,
              }
        });
    }

    public onConsultantButtonClick() {
        this.sendTracking(ActionEventsEnum.ELEMENT_CLICKED, {
            'Product Area Origin': 'Aprenda',
            'Element': 'Botão Falar com um consultor',
            'Group': 'Ainda está com dúvida?',
            'Text': this.consultantButtonText,
            'Time Responsável': 'Sky',
        });
    }
}
